// extracted by mini-css-extract-plugin
module.exports = {"Card":"_1RkWPRsVHWg-G1WftOoduw==","CardHeader":"Fian6biWDiLGzN3kpRC0jQ==","BorderDashed":"ZhQwppVPNPcp1Mm4H9mO6w=="};